/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_TitleInputs */

const tr_iade_iptal_title = /** @type {(inputs: Iade_Iptal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik İptal ve Fesih Politikası`)
};

const en_iade_iptal_title = /** @type {(inputs: Iade_Iptal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Cancellation and Termination Policy`)
};

const de_iade_iptal_title = /** @type {(inputs: Iade_Iptal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richtlinie zu Kündigung und Beendigung des Abonnements`)
};

const ru_iade_iptal_title = /** @type {(inputs: Iade_Iptal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика отмены и расторжения подписки`)
};

/**
* | output |
* | --- |
* | "Subscription Cancellation and Termination Policy" |
*
* @param {Iade_Iptal_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_title = /** @type {((inputs?: Iade_Iptal_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_title(inputs)
	if (locale === "de") return de_iade_iptal_title(inputs)
	if (locale === "ru") return ru_iade_iptal_title(inputs)
	return tr_iade_iptal_title(inputs)
});